import { errorOriginatedInMf, isErrObj, isFPPErrObj } from "./error-utils";
import { FppBackendLogger } from "./logger";

/**
 * Logs an error with the given information to the backend:
 *
 * @param microFrontend name of the microfrontend the error occurred in
 * @param message error message
 * @param stackTrace error stack
 * @param errorTraceId error trace id
 *
 * ONLY USE THIS FUNCTION IF YOU WANT A SPECIFIC ERROR MESSAGE,
 * OTHERWISE USE sendErrorObjToBackend
 *
 * @deprecated use the {@link FppBackendLogger} instead
 */
export const sendErrorToBackend = async (
    microFrontend: string,
    message: string,
    stackTrace?: string,
    errorTraceId?: string,
): Promise<void> => {
    const logger = new FppBackendLogger(microFrontend, microFrontend);
    await logger.logError(message, stackTrace, errorTraceId);
};

/**
 * Logs the given error to the backend if it has originated in the current mf,
 * otherwise does not log
 * (extracts the error message and error stack from the given error):
 *
 * @param microFrontend name of the microfrontend the error occurred in
 * @param mfShorty shorty of the microfrontend the error occurred in
 * @param error error of unknown type
 *
 * @deprecated use the {@link FppBackendLogger} instead
 */
export const sendErrorObjToBackendIfNew = (microFrontend: string, mfShorty: string, error: unknown): Promise<void> => {
    /* prevents sending errors to the backend, that have originally been thrown by the backend
    to avoid duplicate error logging */
    if (isFPPErrObj(error) && !errorOriginatedInMf(mfShorty, error)) return Promise.resolve();
    return sendErrorObjToBackend(microFrontend, error);
};

/**
 * Logs the given error to the backend
 * (extracts the error message and error stack from the given error):
 *
 * @param microFrontend name of the microfrontend the error occurred in
 * @param error error of unknown type
 *
 * @deprecated use the {@link FppBackendLogger} instead
 */
export const sendErrorObjToBackend = (microFrontend: string, error: unknown): Promise<void> => {
    const defaultErrMsg = "An unknown Error occurred.";

    if (!error) {
        return sendErrorToBackend(microFrontend, defaultErrMsg);
    }

    if (isFPPErrObj(error)) {
        return sendErrorToBackend(microFrontend, error.plainMessage, error.stack, error.errorTraceId);
    }

    if (isErrObj(error)) {
        return sendErrorToBackend(
            microFrontend,
            error.message && error.message !== "" ? error.message : defaultErrMsg,
            error.stack,
        );
    }

    let errorStr = error + "";
    errorStr = errorStr === "" ? defaultErrMsg : errorStr;

    return sendErrorToBackend(microFrontend, errorStr);
};
